import { useEffect } from 'react';

const useDocumentHead = ({
  title,
  metaTags = [],
  linkTags = [],
  htmlAttributes = {},
}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (htmlAttributes.lang) {
      document.documentElement.lang = htmlAttributes.lang;
    }

    const createdElements = [];

    metaTags.forEach((tag) => {
      const { name, property, content, httpEquiv } = tag;

      let existingElement = null;
      if (name) {
        existingElement = document.querySelector(`meta[name="${name}"]`);
      } else if (property) {
        existingElement = document.querySelector(`meta[property="${property}"]`);
      } else if (httpEquiv) {
        existingElement = document.querySelector(`meta[http-equiv="${httpEquiv}"]`);
      }

      if (existingElement) {
        existingElement.setAttribute('content', content);
      } else {
        const metaElement = document.createElement('meta');
        if (name) metaElement.setAttribute('name', name);
        if (property) metaElement.setAttribute('property', property);
        if (httpEquiv) metaElement.setAttribute('http-equiv', httpEquiv);
        metaElement.setAttribute('content', content);
        document.head.appendChild(metaElement);
        createdElements.push(metaElement);
      }
    });

    linkTags.forEach((tag) => {
      const { rel, href } = tag;

      let existingElement = document.querySelector(`link[rel="${rel}"]`);

      if (existingElement && rel === 'canonical') {
        existingElement.setAttribute('href', href);
      } else if (!existingElement) {
        const linkElement = document.createElement('link');
        linkElement.setAttribute('rel', rel);
        linkElement.setAttribute('href', href);
        document.head.appendChild(linkElement);
        createdElements.push(linkElement);
      }
    });

    return () => {
      createdElements.forEach((element) => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });
    };
  }, [title, metaTags, linkTags, htmlAttributes]);
};

export default useDocumentHead;
